import { Button } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom';

import { useTranslation } from 'react-i18next';

const MyButton = ({ name, onClickButton, background }) => {
    const { t } = useTranslation();

    const buttonStyle = {
        backgroundColor: "#F0B20B",
        textAlign: "center",
        minWidth: "150px",
        borderRadius: "20px",
        marginTop: "10px",
        background: background != null ? background : "linear-gradient(88deg, #F0B20B 0%, #C37319 63.11%, #8C4125 82.51%, #1B1926 100%)",
        textAlign: "center"
    }

    return (<div>
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <Button variant="contained" style={buttonStyle} onClick={onClickButton}>{name != null ? name : t("confirm").toUpperCase()}</Button>
        </div>
    </div>)
}

export default MyButton;